import { render } from "./ServiceTasks.vue?vue&type=template&id=170a9eb1&ts=true"
import script from "./ServiceTasks.vue?vue&type=script&lang=ts"
export * from "./ServiceTasks.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__